<template>
  <b-container fluid>
    <b-modal
      v-model="isShow"
      size="lg"
      scrollable
      id="modal-1"
      ref="modal"
      :title="title"
      @hidden="resetForm"
    >
      <ValidationObserver ref="observer">
        <b-form @submit.stop.prevent="submitForm">
          <b-row class="my-1">
            <b-col sm="3">
              <label for="contractId"
                >ID Hợp đồng: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 10 }"
                vid="contractId"
                name="contractId"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    type="text"
                    v-model="form.contractId"
                    :state="errors[0] ? false : null"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
              <!-- <b-form-input id="contractId" v-model="form.contractId"></b-form-input> -->
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="customerId"
                >ID Khách hàng: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 3 }"
                vid="customerId"
                name="customerId"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="customerId"
                    v-model="form.customerId"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="customerStatus"
                >Trạng thái khách hàng: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 5 }"
                vid="customerStatus"
                name="customerStatus"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="customerStatus"
                    v-model="form.customerStatus"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="districtCode"
                >Mã quận (District): <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 3 }"
                vid="districtCode"
                name="districtCode"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="districtCode"
                    v-model="form.districtCode"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="email">Email: <sup style="color: red; font-size: small">*</sup></label>
            </b-col>
            <b-col sm="9">
              <ValidationProvider :rules="{ required: true, min: 10 }" vid="email" name="email">
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="email"
                    type="email"
                    v-model="form.email"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="merchantId"
                >ID Merchant: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 10 }"
                vid="merchantMpos_merchantId"
                name="merchantMpos_merchantId"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="merchantId"
                    v-model="form.merchantMpos.merchantId"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="merchantStatus"
                >Trạng thái Merchant: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 5 }"
                vid="merchantMpos_status"
                name="merchantMpos_status"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="merchantStatus"
                    v-model="form.merchantMpos.status"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="merchantOwnerId"
                >Merchant Owner ID: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 10 }"
                vid="merchantOwnerId"
                name="merchantOwnerId"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="merchantOwnerId"
                    v-model="form.merchantOwnerId"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="mobile"
                >Số điện thoại: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider :rules="{ required: true, min: 10 }" vid="mobile" name="mobile">
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="mobile"
                    type="tel"
                    v-model="form.mobile"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="provinceCode"
                >Province Code: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 10 }"
                vid="provinceCode"
                name="provinceCode"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="provinceCode"
                    v-model="form.provinceCode"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="saleStaffId"
                >ID Nhân viên sale: <sup style="color: red; font-size: small">*</sup></label
              >
            </b-col>
            <b-col sm="9">
              <ValidationProvider
                :rules="{ required: true, min: 10 }"
                vid="saleStaffId"
                name="saleStaffId"
              >
                <b-form-group slot-scope="{ errors }">
                  <b-form-input
                    id="saleStaffId"
                    v-model="form.saleStaffId"
                    :state="errors[0] ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
      <template #modal-footer>
        <span v-show="error">{{ error }}</span>
        <b-button type="reset" variant="outline-danger" @click="resetForm"
          ><b-icon icon="x-lg" aria-hidden="true" /> Huỷ</b-button
        >
        <b-button type="submit" variant="outline-primary" :disabled="isLoading" @click="submitForm">
          <b-spinner v-if="isLoading" small></b-spinner>
          <span v-else><b-icon icon="check-lg" animation="spin" aria-hidden="true" /> Lưu</span>
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
  import { Create, Update } from '@/services/customer-support/account'
  import { localize } from 'vee-validate'

  localize({
    en: {
      messages: {
        required: field => `${field} không được để trống`,
        min: (field, { length }) => `${field} phải có ít nhất ${length} kí tự`,
      },
      names: {
        contractId: 'ID hợp đồng',
        customerId: 'ID khách hàng',
        customerStatus: 'Trạng thái khách hàng',
        districtCode: 'Mã quận (District)',
        email: 'Email',
        merchantMpos_merchantId: 'ID Merchant',
        merchantMpos_status: 'Trạng thái Merchant',
        merchantOwnerId: 'Merchant Owner ID',
        mobile: 'Số điện thoại',
        provinceCode: 'Mã tỉnh (Province)',
        saleStaffId: 'ID nhân viên sale',
      },
    },
  })
  export default {
    name: 'AddNewFormModal',
    data() {
      return {
        isShow: false,
        isEdit: false,
        isLoading: false,
        info: {},
        title: '',
        id: '',
        error: '',
        form: {
          contractId: '',
          customerId: '',
          customerStatus: '',
          districtCode: '',
          email: '',
          merchantMpos: {
            merchantId: 0,
            status: '',
          },
          merchantOwnerId: '',
          mobile: '',
          provinceCode: '',
          saleStaffId: '',
          status: 'ACTIVE',
        },
        statusOptions: [
          { value: 'ACTIVE', text: 'Hoạt động' },
          { value: 'INACTIVE', text: 'Khởi tạo' },
          { value: 'LOCK', text: 'Bị khoá' },
        ],
      }
    },
    methods: {
      async handleSubmit(validate) {
        console.log(validate)
        const isValid = await validate()
        if (isValid) {
          this.submitForm()
        } else {
          console.log('Form is invalid')
        }
      },
      async submitForm() {
        const isSuccess = await this.$refs.observer.validate()
        if (!isSuccess) return
        // console.log('Form Submitted:', this.form);
        // console.log('id record: ', this.id);
        // Handle form submission logic here, e.g., send data to API
        this.isLoading = true
        this.error = ''
        try {
          let res
          if (this.isEdit) {
            res = await Update(this.id, this.form)
          } else {
            res = await Create(this.form)
          }
          if (res.result == true && res.code == 1000) {
            this.$refs.modal.hide()
            this.resetForm()
            this.$emit('update-table')
          }
        } catch (error) {
          this.error = error
          console.error('Error submitting form:', error)
        } finally {
          this.isLoading = false
        }
      },
      resetForm() {
        this.form = {
          contractId: '',
          customerId: '',
          customerStatus: '',
          districtCode: '',
          email: '',
          merchantMpos: {
            merchantId: '',
            status: '',
          },
          merchantOwnerId: '',
          mobile: '',
          provinceCode: '',
          saleStaffId: '',
          // status: 'ACTIVE'
        }
        this.$refs.modal.hide()
      },

      show(info, title = 'Thêm mới Account') {
        this.isShow = true
        this.title = title
        this.info = info
        if (info) {
          console.log(info)
          this.isEdit = true
          this.id = info.id
          this.form = {
            contractId: info.contractId ?? '',
            customerId: info.customerId ?? '',
            customerStatus: info.customerStatus ?? '',
            districtCode: info.districtCode ?? '',
            email: info.email ?? '',
            merchantMpos: {
              merchantId: info.merchantMpos?.merchantId ?? '',
              status: info.merchantMpos?.status ?? '',
            },
            merchantOwnerId: info.merchantOwnerId ?? '',
            mobile: info.mobile ?? '',
            provinceCode: info.provinceCode ?? '',
            saleStaffId: info.saleStaffId ?? '',
            // status: info.status ?? ''
          }
        }
      },
    },
  }
</script>

<style scoped>
  /* Add custom styles here if needed */
  .btn {
    & + .btn {
      margin-left: 6px;
    }
  }
</style>
